import TicketResource from "./ticket.resource";

const ticketModule = angular
  .module("app.resources.ticket", [])
  .service("Ticket", TicketResource);

export default ticketModule;



// WEBPACK FOOTER //
// ./src/resources/ticket/ticket.module.js